import React, { Component } from "react";

const DoneIconNew = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.1739 47.8934L53.2953 24.772L48.5217 20.0041L30.1739 38.3519L19.8971 28.4427L15.1235 33.2164L30.1739 47.8934ZM33.477 0.185837C40.0098 0.185837 46.3959 2.12304 51.8277 5.75248C57.2596 9.38192 61.4932 14.5406 63.9932 20.5761C66.4932 26.6117 67.1473 33.253 65.8728 39.6603C64.5983 46.0676 61.4525 51.9531 56.8331 56.5725C52.2137 61.1919 46.3282 64.3377 39.9209 65.6122C33.5136 66.8867 26.8723 66.2326 20.8367 63.7326C14.8012 61.2326 9.64254 56.999 6.0131 51.5671C2.38366 46.1353 0.446457 39.7492 0.446457 33.2164C0.428217 28.8736 1.27012 24.5703 2.9236 20.5546C4.57708 16.5389 7.0094 12.8904 10.0802 9.81958C13.151 6.74878 16.7995 4.31646 20.8152 2.66298C24.8309 1.0095 29.1342 0.167596 33.477 0.185837Z"
        fill={fill}
      />
    </svg>
  );
};

DoneIconNew.defaultProps = {
  width: 68,
  height: 68,
  fill: "white",
};

export default DoneIconNew;
